export default __webpack_public_path__ + "static/media/encantos_qr_code.8c39f82c.jpg";